import TermsAgreement from './TermsAgreement';

export default TermsAgreement;
